import React from "react";
import { MarketingLayout } from "../../components/marketing/MarketingLayout";
import { TwoCol } from "../../components/marketing/TwoCol";

export default function Blog() {
  return (
    <MarketingLayout
      active="blog"
      title="Blog. Crowther."
      description="Writing on sovereignty, deployment, entity resolution, and what it takes to own intelligence in-country."
    >
      <TwoCol
        id="mkt-blog"
        label="Blog"
        title="Blog."
        lede="Writing on sovereignty, deployment, entity resolution, and what it takes to own intelligence in-country."
      >
        <div className="mkt-rows" data-testid="mkt-blog-empty">
          <div className="mkt-row" style={{ gridTemplateColumns: "1fr" }}>
            <div>
              <p className="mkt-serif-lead">First essays are on the way.</p>
              <p className="mkt-body" style={{ marginTop: 16, maxWidth: "56ch" }}>
                Rather than pad the shelf, we are letting these arrive when they are worth reading. If a specific question about deployment, entity resolution, or sovereignty is on your mind, write to us and we will make sure the answer reaches you when we publish it.
              </p>
            </div>
          </div>
        </div>
      </TwoCol>
    </MarketingLayout>
  );
}
